import { createApp } from 'vue';
import Vuelidate from '@vuelidate/core';
import VueScrollTo from 'vue-scrollto';
import { createVfm } from 'vue-final-modal';
import 'vue-final-modal/dist/style.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import VueGtag from 'vue-gtag-next';
// import VCalendar from 'v-calendar';
import App from './App.vue';
import axios from './plugins/axios';
// import './registerServiceWorker';
import router from './router';
import store from './store';

const vfm = createVfm();
const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(Vuelidate);
app.use(VueScrollTo);
app.use(vfm);
// app.use(VueGtag, {
//   property: {
//     id: 'GTM-M6W59596',
//     router,
//   },
// });
// app.use(VCalendar, {});
app.mount('#app');
